import { ActivityCategory } from 'interfaces/ActivityInterfaces';
import PaddingWrap from 'components/shared/PaddingWrap';

interface ActivityCategoryProps {
	activityCategory: ActivityCategory;
}

function ActivityCategoryDisplay({ activityCategory }: ActivityCategoryProps) {
	return (
		<PaddingWrap sx={{ paddingTop: '20px', textAlign: 'center' }}>
			<h2 style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.2)', paddingTop: '15px', paddingBottom: '15px' }}>{activityCategory.title}</h2>
			{activityCategory.descShort ? <p>{activityCategory.descShort}</p> : null}
		</PaddingWrap>
	);
}

export default ActivityCategoryDisplay;